import countryList_ar from './countryList_ar.json';
import countryList_az from './countryList_az.json';
import countryList_bg from './countryList_bg.json';
import countryList_bn from './countryList_bn.json';
import countryList_bs from './countryList_bs.json';
import countryList_cs from './countryList_cs.json';
import countryList_cy from './countryList_cy.json';
import countryList_da from './countryList_da.json';
import countryList_de from './countryList_de.json';
import countryList_el from './countryList_el.json';
import countryList_en from './countryList_en.json';
import countryList_es from './countryList_es.json';
import countryList_et from './countryList_et.json';
import countryList_fa from './countryList_fa.json';
import countryList_fi from './countryList_fi.json';
import countryList_fr from './countryList_fr.json';
import countryList_he from './countryList_he.json';
import countryList_hi from './countryList_hi.json';
import countryList_hr from './countryList_hr.json';
import countryList_hu from './countryList_hu.json';
import countryList_hy from './countryList_hy.json';
import countryList_id from './countryList_id.json';
import countryList_is from './countryList_is.json';
import countryList_ja from './countryList_ja.json';
import countryList_ko from './countryList_ko.json';
import countryList_it from './countryList_it.json';
import countryList_lv from './countryList_lv.json';
import countryList_lt from './countryList_lt.json';
import countryList_mk from './countryList_mk.json';
import countryList_ms from './countryList_ms.json';
import countryList_nl from './countryList_nl.json';
import countryList_no from './countryList_no.json';
import countryList_pl from './countryList_pl.json';
import countryList_pt from './countryList_pt.json';
import countryList_ro from './countryList_ro.json';
import countryList_ru from './countryList_ru.json';
import countryList_sk from './countryList_sk.json';
import countryList_sl from './countryList_sl.json';
import countryList_sr from './countryList_sr.json';
import countryList_sq from './countryList_sq.json';
import countryList_sv from './countryList_sv.json';
import countryList_ta from './countryList_ta.json';
import countryList_th from './countryList_th.json';
import countryList_tr from './countryList_tr.json';
import countryList_uk from './countryList_uk.json';
import countryList_ur from './countryList_ur.json';
import countryList_vi from './countryList_vi.json';
import countryList_zh from './countryList_zh.json';
import countryList_zh_Hant from './countryList_zh-Hant.json';

const countryDataMap = {
    countryList_ar,
    countryList_az,
    countryList_bg,
    countryList_bn,
    countryList_bs,
    countryList_cs,
    countryList_cy,
    countryList_da,
    countryList_de,
    countryList_el,
    countryList_en,
    countryList_es,
    countryList_et,
    countryList_fa,
    countryList_fi,
    countryList_fr,
    countryList_he,
    countryList_hi,
    countryList_hr,
    countryList_hu,
    countryList_hy,
    countryList_id,
    countryList_is,
    countryList_it,
    countryList_ja,
    countryList_ko,
    countryList_lt,
    countryList_lv,
    countryList_mk,
    countryList_ms,
    countryList_nl,
    countryList_no,
    countryList_pl,
    countryList_pt,
    countryList_ro,
    countryList_ru,
    countryList_sk,
    countryList_sl,
    countryList_sq,
    countryList_sr,
    countryList_sv,
    countryList_ta,
    countryList_th,
    countryList_tr,
    countryList_uk,
    countryList_ur,
    countryList_vi,
    countryList_zh,
    countryList_zh_Hant,
}

export default {

}

export function getCountryInfoList(lang_code) {
    const list = countryDataMap["countryList_" + lang_code] || countryList_en // 没匹配到就用中文
    return list
}